import React from 'react';
import { renderLayerDom } from '@/utils/render-kit';
import { ILayerProps } from '@/version-types';
import QRCodeLayerContent from './layer-content';

export function renderLayerContentToDOM(layer: ILayerProps): Promise<() => void> {
    return new Promise((resolve) => {
        const removeDomHandle = renderLayerDom(
            <QRCodeLayerContent
                layer={layer}
                renderEnd={() => {
                    resolve(removeDomHandle);
                }}
            />,
        );
    });
}
